import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { MessageService, ConfirmationService, PrimeNGConfig, ConfirmEventType } from 'primeng/api';
import { Table } from 'primeng/table';
import { IChoferDisponible } from '../models/choferdisponible';
import { IColaboradorConfirmacion } from '../models/colaborador_confirmacion';
import { IColumnas } from '../models/columnas';
import ICredencialUsuario from '../models/credencial';
import { IEstatus } from '../models/estatus';
import { IChoferForm } from '../models/formchofer';
import { IModelDiaReal } from '../models/modeldiareal';
import { IMovDiarioUnidadCompleto } from '../models/movdiariocompleto';
import { IMovDiarioUnidad } from '../models/movdiariounidad';
import { IOperacionDia } from '../models/operaciondia';
import { IPuestochofer } from '../models/puestochofer';
import { IResultadoGeneral } from '../models/resultadogeneral';
import { IUnidadDisponible } from '../models/unidaddisponible';
import { AdminpaounidadesService } from '../services/adminpaounidades.service';
import { AuthService } from '../services/auth.service';
import { ChoferService } from '../services/chofer.service';
import { ProyeccionService } from '../services/proyeccion.service';
import { UnidadtransporteService } from '../services/unidadtransporte.service';
import { Iaprovechamiento } from '../models/aprovechamiento';
import { CiudadService } from '../services/ciudad.service';
import { ICiudad } from '../models/ciudad';
import { ISinServicio } from '../models/sinservicio';
import { IpostguardarUnidadadsinruta } from '../models/postguardarUnidadadsinruta';
import { ICriterio } from '../models/criterioasignacion';
import * as saveAs from 'file-saver';
import { IConMantenimiento } from '../models/consultaMantenimiento';




//import { Iaprovechamiento } from '../models/aprovechamiento';
@Component({
  selector: 'app-real',
  templateUrl: './real.component.html',
  styleUrls: ['./real.component.scss']
})

export class RealComponent implements OnInit {
  @ViewChild('dt1') dt!: Table;
  @ViewChild('dt2') dt2!: Table;
  @ViewChild('dt3') dt3!: Table;
  @ViewChild('dt4') dt4!: Table;
  @ViewChild('dt5') dt5!: Table;
  @ViewChild('dt6') dt6!: Table;
  lstOperacionDiariaReal: IOperacionDia[] = [];
  lstOperacionDiariaReal_sinruta: IOperacionDia[] = [];
  lstOperacionDiariaUnidades: IMovDiarioUnidad[] = [];
  cols: IColumnas[] = [];

  clv_operacion: number = 0;
  dia: any = new Date().toISOString().substring(0, 10);
  fecha_filtrada: any = new Date().toISOString().substring(0, 10);

  fecha_fil_sin_reg: any = new Date().toISOString().substring(0, 10);
  fecha_dia: any = new Date().toISOString().substring(0, 10);

  fecha_dia_final: any = null;
  ServiciosSinFinalizar: any[] = [];
  fecha_dia_final_editar: any = null;
  checked: boolean = true;
  checked2: boolean = false;
  lstMovUnidades: IMovDiarioUnidad[] = [];
  dspEditar: boolean = false;
  nombre_ruta_Editable: string = '';
  fecha_dia_editable: string = '';
  hora: any;
  DilogEditar: boolean = false;
  id_pao_unidades: number = 0;
  permite_editar: boolean = false;
  permite_eliminar: boolean = false;


  REGEX_names = '^[0-9]{7,8}$';
  REGEX_names2 = '^[0-9]{8}$';

  dspsinruta: boolean = false
  Dspaddsinruta: boolean = false
  habilitar: boolean = false;
  lstsinServicio: ISinServicio[] = [];
  habilitaragregar: boolean = true;
  lstpostguardarUnidadadsinruta: IpostguardarUnidadadsinruta[] = [];
  //Unidades agregadadas al dia
  model: IModelDiaReal = {
    id_registro: 0,
    id_tipo_transporte: 0,
    id_ciudad: 0,
    id_ruta: 0,
    fecha: '',
    clv_operacion: 0,
  };


  reactiveForm: FormGroup = new FormGroup({
    fecha: new FormControl(this.fecha_dia, [Validators.required]),
    id_ruta_travel: new FormControl(null),
    rostering_id: new FormControl(null),
    unidades: new FormControl(0, [Validators.required]),
    choferes: new FormControl(0, [Validators.required]),
    clv_retardo: new FormControl<number | null>(null),
    clv_retardo1: new FormControl(0, []),
    clv_retardo2: new FormControl(0, []),
    id_puesto1: new FormControl(null),
    id_puesto2: new FormControl(null),
    cod_adicional1: new FormControl(null),
    cod_adicional2: new FormControl(null),
    clv_confirma_combustible: new FormControl<number | null>(null),
    clv_confirma_casetas: new FormControl<number | null>(null),
    id_tipo_aprovechamiento: new FormControl(null, [Validators.required]),
  });

  sinservicioForm: FormGroup = new FormGroup({
    fecha_fil_sin_reg: new FormControl(new Date().toISOString().substring(0, 10), [Validators.required]),
    id_ciudad_hm: new FormControl(9, [Validators.required]),
    id_ruta_travel: new FormControl(null, [Validators.required, Validators.pattern(this.REGEX_names)]),
    rostering_id: new FormControl(null, [Validators.required, Validators.pattern(this.REGEX_names2)]),
    id_unidad_transporte: new FormControl(0, [Validators.required]),
    cod_chofer: new FormControl(0, [Validators.required]),
    id_puesto1: new FormControl(null),
    id_puesto2: new FormControl(null),
    cod_adicional1: new FormControl(null),
    cod_adicional2: new FormControl(null),
    id_tipo_aprovechamiento: new FormControl(null, [Validators.required]),
    folio_serviciosinruta: new FormControl(0),
    id_folio: new FormControl(0),
  });



  diasTrabajados: number = 0;

  criterioForm: FormGroup = new FormGroup({
    id_ciudad_hm: new FormControl(null, [Validators.required]),
    fecha_fil: new FormControl(() => {
      const y = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
      const m = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
      const d = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
      return `${y}-${m}-${d}`;
    }, [Validators.required])
  });
  consMantenimientoForm: FormGroup = new FormGroup({
    id_ciudad_hm: new FormControl(null, [Validators.required])
  });
     // new Date().toISOString().substring(0, 10)



  lstpuestos: IPuestochofer[] = [{
    id: 1,
    nombre: 'DRIVER',
    descripcion_Puesto: ''
  },
  {
    id: 2,
    nombre: 'AUXILIAR',
    descripcion_Puesto: ''
  }];
  reactiveForm2!: FormGroup;
  //Consulta de Unidades
  dspEditarConsulta: boolean = false;

  //Unidades Disponibles y Chofer
  lstUnidadesDisponibles: IUnidadDisponible[] = [];
  lstChoferesDisponibles: IChoferDisponible[] = [];

  lstaprovechamiento: Iaprovechamiento[] = [];

  loading: boolean = false;
  loading_sin: boolean = false;
  loading_sin_rut: boolean = false;
  loadingEditar: boolean = false;
  selectedUnidad: IUnidadDisponible = {
    num_economico: '',
    clave_ciudadDestino: 0,
    id_unidad_transporte: 0
  };

  credsOpciones = { clv_create: false, clv_read: false, clv_update: false, clv_delete: false, clv_cancel: false };

  selectedChofer: IChoferDisponible = {
    cod_chofer: 0,
    nombre_completo: '',
    id_ciudad_hm: 0,
    id_puesto_chofer: 0,
    clave_tipoTransporte: 0
  };
  dspConfirmarAsignacion: boolean = false;
  leyenda_IdRutaTravelId: string = '';
  leyenda_unidad: string = '';
  leyenda_chofer: string = '';
  resultado: IResultadoGeneral = {
    clv_estatus: 0,
    messageDetails: ''
  };
  color_rojo_especial: string = '#FF0000';

  //Boton y Eventos Especiales
  desactivarBotonGuardar: boolean = false;
  descripcion_ruta: string = '';
  reactiveform_paso: IChoferForm = {
    fecha: '',
    choferes: 0,
    unidades: 0
  };
  lstCiudades: ICiudad[] = [];
  lstCiudadescriterio: ICiudad[] = [];
  selectedCiudad: ICiudad = {
    id: 0,
    nombre: '',
    clave_Estado: '',
    id_ciudad_principal: 0
  };
  dspServicios: boolean = false;

  //Habilitar botones
  dsbUnidad: boolean = true;
  dsbChofer: boolean = true;
  dsbRutas: boolean = true;
  //Registro
  user: ICredencialUsuario = {};
  lstEstatusEspecial: IEstatus[] = [{
    id: 1,
    nombre: 'ESPECIAL'
  },
  {
    id: 0,
    nombre: 'NORMAL'
  }];
  nombre_proyecto_general: string = '';
  cod_usuario_general: string = '';
  //Permiso para eliminar informacion
  clv_pa: number = 0;
  loadingServicios: boolean = false;
  lstConfirmacionColaboradores: IColaboradorConfirmacion[] = [];
  clv_especial: number = 0;
  dspMantenimiento: boolean = false;
  lstManteniento: IConMantenimiento[] = [];
  loadingManetnimiento:boolean = false;
  loadingManetnimiento_reporte:boolean = false;

  constructor(private proyeccionService: ProyeccionService,
    private unidadService: UnidadtransporteService,
    private messageService: MessageService,
    private choferService: ChoferService,
    private confirmationService: ConfirmationService, private primengConfig: PrimeNGConfig, private fb: FormBuilder,
    private auth: AuthService,
    private ciudadService: CiudadService,
    private adminpaounidadesService: AdminpaounidadesService) {
    this.cargarInformacionUsuario();
    this.reactiveForm.controls['cod_adicional1'].valueChanges.subscribe(data => {
      this.filtrarListadoColaboradores(data);
    });
    this.reactiveForm.controls['cod_adicional2'].valueChanges.subscribe(data => {
      this.filtrarListadoColaboradores(data);
    });
    this.reactiveForm.controls['choferes'].valueChanges.subscribe(data => {
      this.filtrarListadoColaboradores(data);
    });
    //
    this.sinservicioForm.controls['cod_adicional1'].valueChanges.subscribe(data => {
      this.filtrarListadoColaboradoressinRuta(data);
    });
    this.sinservicioForm.controls['cod_adicional2'].valueChanges.subscribe(data => {
      this.filtrarListadoColaboradoressinRuta(data);
    });
    this.sinservicioForm.controls['cod_chofer'].valueChanges.subscribe(data => {
      this.filtrarListadoColaboradoressinRuta(data);
    });

  }
  ngOnInit(): void {
    this.llenarColumnas();
    this.inicializarFechas();
    this.llenarInformacionAutomaticaDia();

    //this.crearFormulario();
    this.cargarListadoCiudades();
    this.crearFormularioFB();
    this.getcataprovechamiento();
  }

  filtrarListadoColaboradores(cod_chofer: number) {
    let chofer = this.reactiveForm.get('choferes')?.value == null ? 0 : this.reactiveForm.get('choferes')?.value;
    let chofer1 = this.reactiveForm.get('cod_adicional1')?.value == null ? 0 : this.reactiveForm.get('cod_adicional1')?.value;
    let chofer2 = this.reactiveForm.get('cod_adicional2')?.value == null ? 0 : this.reactiveForm.get('cod_adicional2')?.value;

    //se agrego la variable id_pao_unidades
    if (this.id_pao_unidades != 0) {
      if (this.lstChoferesDisponibles.length > 0) {

        this.lstChoferesDisponibles.map((valor) => {

          if (valor.cod_chofer == cod_chofer) {
            valor.disabled = 1;
          }
          else if (valor.cod_chofer != chofer && valor.cod_chofer != chofer1 && valor.cod_chofer != chofer2 && valor.deshabilitado == false) {
            valor.disabled = 0;
          }
        });
      }

    }
    else {
      if (this.lstChoferesDisponibles.length > 0) {
        this.lstChoferesDisponibles.map((valor) => {
          if (valor.cod_chofer == cod_chofer) {
            valor.disabled = 1;
          }
          else if (valor.cod_chofer != chofer && valor.cod_chofer != chofer1 && valor.cod_chofer != chofer2 && valor.deshabilitado == false) {
            valor.disabled = 0;
          }
        });
      }
    };
  }
  filtrarListadoColaboradoressinRuta(cod_chofer: number) {
    let chofer = this.sinservicioForm.get('cod_chofer')?.value == null ? 0 : this.sinservicioForm.get('cod_chofer')?.value;
    let chofer1 = this.sinservicioForm.get('cod_adicional1')?.value == null ? 0 : this.sinservicioForm.get('cod_adicional1')?.value;
    let chofer2 = this.sinservicioForm.get('cod_adicional2')?.value == null ? 0 : this.sinservicioForm.get('cod_adicional2')?.value;

    //se agrego la variable id_pao_unidades
    if (this.id_pao_unidades != 0) {
      if (this.lstChoferesDisponibles.length > 0) {

        this.lstChoferesDisponibles.map((valor) => {

          if (valor.cod_chofer == cod_chofer) {
            valor.disabled = 1;
          }
          else if (valor.cod_chofer != chofer && valor.cod_chofer != chofer1 && valor.cod_chofer != chofer2 && valor.deshabilitado == false) {
            valor.disabled = 0;
          }
        });
      }

    }
    else {
      if (this.lstChoferesDisponibles.length > 0) {
        this.lstChoferesDisponibles.map((valor) => {
          if (valor.cod_chofer == cod_chofer) {
            valor.disabled = 1;
          }
          else if (valor.cod_chofer != chofer && valor.cod_chofer != chofer1 && valor.cod_chofer != chofer2 && valor.deshabilitado == false) {
            valor.disabled = 0;
          }
        });
      }
    };
  }


  cancelarServicios() {
    this.dspServicios = false;
  }

  cargarListadoCiudades() {
    this.ciudadService.getListadoCiudades().subscribe((resp) => {
      this.lstCiudades = resp;
      this.lstCiudadescriterio = resp
      this.lstCiudadescriterio.unshift({ id: 0, nombre: 'TODAS LAS CIUDADES', clave_Estado: '', id_ciudad_principal: 0 })
    },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error en cargar <Ciudades>', detail: 'Contacte al Administrador del Sitio' });
      });
  }

  getcataprovechamiento() {
    this.loading = true;
    this.unidadService.getcataprovechamiento().subscribe((resp) => {
      this.lstaprovechamiento = resp;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }, (error) => {
      this.loading = false;
      this.mostrarDialogoInformativoSinInformacion('<b>Error al obtener listado</b>. de aprovechamiento.');
    });
  }




  eliminarMovimiento(data: IMovDiarioUnidad) {
    let data_enviar: IMovDiarioUnidadCompleto = {
      id: data.idx,
      id_pao: data.idx_pao_diario,
      id_ruta: data.id_ruta,
      fecha: data.fecha,
      id_unidad: data.id_unidad_transporte,
      id_chofer: data.cod_chofer,
      cod_usuario: this.user.cod!,
      clv_confirm: 1
    };
    this.adminpaounidadesService.eliminarMovimiento(data_enviar).subscribe((resp) => {
      this.resultado = resp;
      //if para evitar que las ruts con recursoos ya asigandos sean eliminados itzael
      if (this.resultado.clv_estatus == -2) {
        let mssg = this.resultado.messageDetails.length > 1 ? this.resultado.messageDetails : 'NO se pueden eliminar rutas con recursos ya asignados o Facturas activas.'
        this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Atención en <Eliminar Servicio>', detail: mssg });
      }
      else {
        this.messageService.add({ key: 'msj', severity: 'success', summary: 'Actualización', detail: 'La informacion se almaceno de forma correcta' });
      }
      this.cancelarMostrarConfirmacion();
      this.cancelarAgregarUnidadyChofer();
      this.cancelarMostrarConsulta();
      this.llenarInformacionAutomaticaDiaAlGuardar(data_enviar.fecha.substring(0, 10));
    },
      (error) => {
        this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error en <Eliminar Servicio>', detail: 'Contacte al Administrador del Sitio' });
      });
  }

  confirmarDesactivar(data: IMovDiarioUnidad) {
    this.confirmationService.confirm({
      message: 'Esta seguro que desea <b>Eliminar</b> el registro de Ruta <b>' + data.nombre_ruta + '</b> del Dia (' + data.fecha.substring(0, 10) + ') ?',
      header: 'Confirmación de Eliminar',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.eliminarMovimiento(data);
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Rechazado', detail: 'Se Rechazo la operación' });
            break;
          case ConfirmEventType.CANCEL:
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Se Cancelado la operación' });
            break;
        }
      }
    });
  }

  confirmarCancelarRuta(data: IMovDiarioUnidad) {
    let texto: string = data.clv_cancelado == 1 ? 'HABILITAR' : 'CANCELAR';
    this.confirmationService.confirm({
      message: 'Esta seguro que desea <b>' + texto + '</b> el registro de Ruta <b>' + data.nombre_ruta + '</b> del Dia (' + data.fecha.substring(0, 10) + ') con la Unidad <b> ' +
        data.num_economico + '</b> ?',
      header: 'Confirmación de ' + texto + ' Ruta',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.cancelarMovimiento(data);
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Rechazado', detail: 'Se Rechazo la operación' });
            break;
          case ConfirmEventType.CANCEL:
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Se Cancelado la operación' });
            break;
        }
      }
    });
  }


  //editar ruta itzael
  confirmarEditarRuta(data: IMovDiarioUnidad) {

    this.DilogEditar = true;
    //editar
    let texto: string = data.clv_cancelado == 1 ? 'HABILITAR' : 'CANCELAR';
    this.confirmationService.confirm({
      message: 'Esta seguro que desea <b>' + texto + '</b> el registro de Ruta <b>' + data.nombre_ruta + '</b> del Dia (' + data.fecha.substring(0, 10) + ') con la Unidad <b> ' +
        data.num_economico + '</b> ?',
      header: 'Confirmación de ' + texto + ' Ruta',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.editarUnidadxDia(data);
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Rechazado', detail: 'Se Rechazo la operación' });
            break;
          case ConfirmEventType.CANCEL:
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Se Cancelado la operación' });
            break;
        }
      }
    });
  }

  cancelarMovimiento(data: IMovDiarioUnidad) {
    let data_enviar: IMovDiarioUnidadCompleto = {
      id: data.idx,
      id_pao: data.idx_pao_diario,
      id_ruta: data.id_ruta,
      fecha: data.fecha,
      id_unidad: data.id_unidad_transporte,
      id_chofer: data.cod_chofer,
      cod_usuario: this.user.cod!,
      clv_confirm: 1
    };
    this.adminpaounidadesService.cancelarMovimiento(data_enviar).subscribe((resp) => {
      this.resultado = resp;
      if (this.resultado.clv_estatus == -2) {
        this.mostrarDialogoInformativoAdicionales(this.resultado.messageDetails);
        this.cancelarMostrarConfirmacion();
      } else {
        this.messageService.add({ key: 'msj', severity: 'success', summary: 'Actualización', detail: 'La informacion se almaceno de forma correcta' });
        this.cancelarMostrarConfirmacion();
        this.cancelarAgregarUnidadyChofer();
        this.cancelarMostrarConsulta();
        this.llenarInformacionAutomaticaDiaAlGuardar(data.fecha.substring(0, 10));
      }
    },
      (error) => {
        this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error en <Cancelar Servicio>', detail: 'Contacte al Administrador del Sitio' });
      });
  }

  cargarInformacionUsuario() {
    this.user = this.auth.user;
  }

  crearFormularioFB() {
    this.reactiveForm2 = this.fb.group({
      fecha: new FormControl(this.fecha_dia),
      id_ruta_travel: new FormControl('', []),
      unidades: new FormControl(0, [
        Validators.required
      ]),
      choferes: new FormControl(0, [
        Validators.required
      ])
    });
  }

  asignarChofer(data: any) {
    let cod_chofer = data;
    this.lstChoferesDisponibles.map((valor) => {
      if (valor.cod_chofer = cod_chofer) {
        this.selectedChofer = valor;
      }
    });
  }

  asignarUnidad(data: any) {
    let id_unidad_transporte = data;
    this.lstUnidadesDisponibles.map((unidad) => {
      if (unidad.id_unidad_transporte = id_unidad_transporte) {
        this.selectedUnidad = unidad;
      }
    });
  }

  crearFormulario() {
    this.reactiveForm = new FormGroup({
      fecha: new FormControl(this.fecha_dia, [
        Validators.required
      ]),
      id_ruta_travel: new FormControl('', []),
      unidades: new FormControl(0, [
        Validators.required
      ]),
      choferes: new FormControl(0, [
        Validators.required
      ])
    });
  }

  mostrarFormularioReactivo() {
  }




  asignarValorChofer() {
    let cod_chofer = this.reactiveForm.get('choferes')?.value;
    this.selectedChofer = cod_chofer;

  }
  //itzael id_ruta_travel
  get id_ruta_travel() {
    return this.reactiveForm.get('id_ruta_travel')!;
  }

  get unidades() {
    return this.reactiveForm.get('unidades')!;
  }

  get choferes() {
    return this.reactiveForm.get('choferes')!;
  }

  get ruta() {
    return this.reactiveForm.get('ruta')!;
  }


  inicializarFechas() {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    let restarTresDias = new Date(dateFormat);

    this.fecha_dia_final = dateFormat;
    this.fecha_dia_final_editar = restarTresDias.setDate(restarTresDias.getDate() - 3);
    this.dia = dateFormat;
    this.fecha_filtrada = dateFormat;
    this.fecha_fil_sin_reg = dateFormat;
    this.fecha_dia = dateFormat;



  }


  /*Filtro General para la informacion de tabla*/
  applyFilterGlobal($event: any, stringVal: any) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  applyFilterGlobal2($event: any, stringVal: any) {
    this.dt2.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }
  applyFilterGlobal3($event: any, stringVal: any) {
    this.dt3.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }
  applyFilterGlobal4($event: any, stringVal: any) {
    this.dt4.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }
  applyFilterGlobal5($event: any, stringVal: any) {
    this.dt5.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }
  applyFilterGlobal6($event: any, stringVal: any) {
    this.dt6.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }



  padTo2Digits(num: number) {
    return num.toString().padStart(2, '0');
  }



  llenarColumnas() {
    this.cols = [{ field: 'nombre_ciudad', header: 'Ciudad' },
    { field: 'nombre_cliente', header: 'Cliente' },
    { field: 'nombre_proyecto', header: 'Proyecto' },
    { field: 'nombre_ruta', header: 'Ruta' },
    { field: 'nombre_unidad', header: 'Unidad' },
    { field: '', header: '' },
    { field: '', header: '' }];
  }

  zeroAdd(n: string): string {
    return n.length < 5 ? this.zeroAdd('0' + n) : n;
  }

  obtnCred() {
    let cred = this.lstOperacionDiariaReal[0].clv_accion_reg != undefined ? this.lstOperacionDiariaReal[0].clv_accion_reg : 0;

    if (cred >= 0) {
      let crd = this.zeroAdd(cred.toString(2));
      this.credsOpciones =
      {
        clv_create: Boolean(Number(crd.substring(0, 1))).valueOf()
        , clv_read: Boolean(Number(crd.substring(1, 2))).valueOf()
        , clv_update: Boolean(Number(crd.substring(2, 3))).valueOf()
        , clv_delete: Boolean(Number(crd.substring(3, 4))).valueOf()
        , clv_cancel: Boolean(Number(crd.substring(4, 5))).valueOf()
      }
    }
    else {
      this.credsOpciones =
      {
        clv_create: false
        , clv_read: false
        , clv_update: false
        , clv_delete: false
        , clv_cancel: false
      }
    }
  }

  FiltrarFechaDiariaRuta() {
    this.loading = true;
    this.dia = this.fecha_filtrada;
    this.fecha_dia = this.fecha_filtrada;
    this.clv_operacion = 0;
    this.proyeccionService.getListadoOpDia(1, this.fecha_filtrada, this.user.cod).subscribe((resp) => {
      this.lstOperacionDiariaReal = [];
      setTimeout(() => {
        this.lstOperacionDiariaReal = resp;
        this.obtnCred();

        if (this.lstOperacionDiariaReal.length == 0) {
          this.loading = false;
          this.mostrarDialogoInformativoSinInformacion('<b>No Existe</b> información de Rutas para la Fecha ' + this.fecha_filtrada + ' seleccionada');
        }
        else {
          this.clv_operacion = resp[0].clv_operacion;
          this.loading = false;
        }

      },
        600);
    },
      (error) => {
        this.mostrarDialogoInformativoSinInformacion('<b>ERROR</b> en Cargar Movimientos del Dia(Operación Diaria)');
        this.loading = false;
      });
  }

  llenarInformacionAutomaticaDia() {
    this.loading = true;
    this.proyeccionService.getListadoOpDia(1, this.fecha_dia, this.user.cod).subscribe((resp) => {
      setTimeout(() => {
        this.loading = false;
        this.lstOperacionDiariaReal = resp;
        this.obtnCred();
        this.clv_pa = resp.length > 0 ? resp[0].clv_pa : 0;
        if (this.lstOperacionDiariaReal.length == 0) {
          this.loading = false;
          this.mostrarDialogoInformativoSinInformacion('<b>No Existe</b> información de Rutas para la Fecha seleccionada');
        }
        else {
          this.clv_operacion = resp[0].clv_operacion;
        }
      },
        600);
    },
      (error) => {
        this.mostrarDialogoInformativoSinInformacion('<b>ERROR</b> en Cargar Movimientos del Dia(Operación Diaria- ' + this.fecha_dia + ' )');
        this.loading = false;
      });
  }



  llenarInformacionAutomaticaDiaAlGuardar(fecha: any) {
    this.loading = true;
    this.proyeccionService.getListadoOpDia(1, fecha, this.user.cod).subscribe((resp) => {
      setTimeout(() => {
        this.loading = false;
        this.lstOperacionDiariaReal = resp;
        this.obtnCred();
        if (this.lstOperacionDiariaReal.length == 0) {
          this.loading = false;
          this.mostrarDialogoInformativoSinInformacion('<b>No Existe</b> información de Rutas para la Fecha seleccionada');
        }
      },
        600);
    },
      (error) => {
        this.mostrarDialogoInformativoSinInformacion('<b>ERROR</b> en Cargar Movimientos del Dia(Operación Diaria- ' + fecha + ' )');
        this.loading = false;
      });
  }

  mostrarDialogoFolio(mensaje_usuario: string) {

    let mensaje_completo = 'El <b>#Folio</b> asignado para el Servicio es: <b>' + mensaje_usuario + '</b>';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Asignación de Folio',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'success', summary: 'Actualización', detail: 'La informacion se almaceno de forma correcta' });
      },
      key: "folio"
    });
  }

  mostrarDialogoFolioEditar(mensaje_usuario: string) {

    let mensaje_completo: string = '<b>' + mensaje_usuario + '</b>';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Asignación de Folio',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'success', summary: 'Actualización', detail: 'La informacion se almaceno de forma correcta' });
      },
      key: "folio"
    });
  }

  mostrarDialogoInformativoSinInformacion(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '. <b>Contacte al Administrador.</b>';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      key: "sinInformacionDialog"
    });
  }

  MostrarInformacionUnidades(id: number, data: IOperacionDia) {
  }
  tipo_aprovechamiento?: string = ''
  clv_fin_operacion?: number = 0;
  cargarInformacionDeMovDiarioUnidades(idx_pao_diario: number, id_ruta: number, fecha: string, nom_proyecto: string) {

    this.nombre_proyecto_general = nom_proyecto;
    this.loadingEditar = true;
    this.proyeccionService.getListadoUnidadesDia(1, idx_pao_diario, id_ruta, fecha).subscribe((resp) => {
      this.lstOperacionDiariaUnidades = resp;

      this.lstOperacionDiariaUnidades.forEach((unidad) => {
        let aprovechamiento = this.lstaprovechamiento.find(x => x.id_tipo_aprovechamiento === unidad.id_tipo_aprovechamiento);
        if (aprovechamiento) {
          unidad.tipo_aprovechamiento = aprovechamiento.nombre;

        }
      });
      //  this.clv_fin_operacion = this.lstOperacionDiariaUnidades[0].;
      this.clv_fin_operacion = resp.length > 0 ? resp[0].clv_fin_operacion : 0;
      // this.clv_operacion=data.clv_operacion
      this.dspEditarConsulta = true;
      setTimeout(() => {
        this.loadingEditar = false;
      }, 800);
    },
      () => {
        this.loadingEditar = false;
        this.mostrarDialogoInformativoSinInformacion('<b>Error</b> al cargar Unidades por el dia de Ruta.');
      });

  }



  mostrarDialogoInformativoAdicionales(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario;
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
      },
      reject: () => {
      },
      key: "sinInformacionDialog"
    });
  }


  confirmarInformacionAntesGuardar() {
    let cod_1 = this.reactiveForm.get('cod_adicional1')?.value;
    let cod_2 = this.reactiveForm.get('cod_adicional2')?.value;
    let id_pues1 = this.reactiveForm.get('id_puesto1')?.value == 0 ? null : this.reactiveForm.get('id_puesto1')?.value;
    let id_pues2 = this.reactiveForm.get('id_puesto2')?.value == 0 ? null : this.reactiveForm.get('id_puesto2')?.value;
    if (((cod_1 > 0 || cod_1 != null) && id_pues1 == null) || ((cod_2 > 0 || cod_2 != null) && id_pues2 == null)
      || ((id_pues1 > 0 || id_pues1 != null) && cod_1 == null)
      || ((id_pues2 > 0 || id_pues2 != null) && cod_2 == null)) {
      this.mostrarDialogoInformativoAdicionales('La informacion de <b>Colaboradores Adicionales</b> debe estar Completa(Puesto/Nombre).');
    } else {
      this.leyenda_IdRutaTravelId = this.reactiveForm.get('id_ruta_travel')?.value;
      this.leyenda_unidad = this.reactiveForm.get('unidades')?.value;
      this.leyenda_chofer = this.reactiveForm.get('choferes')?.value;
      this.lstConfirmacionColaboradores = [];

      //verificar aqui itzael
      let num_economico = this.obtenerNumeroEconomico(this.reactiveForm.get('unidades')?.value);
      // let aprovechamiento = this.reactiveForm.get('id_tipo_aprovechamiento')?.value;
      let aprovechamiento = this.lstaprovechamiento.find(x => x.id_tipo_aprovechamiento === this.reactiveForm.controls['id_tipo_aprovechamiento'].value);

      if (this.reactiveForm.get('choferes')?.value != null) {
        let nombre = this.obtenerNombreColaborador(this.reactiveForm.get('choferes')?.value);
        let puesto = 'DRIVER';
        this.lstConfirmacionColaboradores.push({
          num_economico: num_economico,
          desc_ruta: this.descripcion_ruta,
          nombre_completo: nombre,
          desc_puesto: puesto,
          aprovechamiento: aprovechamiento?.nombre,
          clv_retardo: (this.reactiveForm.get('clv_retardo')?.value == null || this.reactiveForm.get('clv_retardo')?.value == 0 ? 'NO' : 'SI')
        });
      }
      if (this.reactiveForm.get('cod_adicional1')?.value != null) {
        let nombre_adicional1 = this.obtenerNombreColaborador(this.reactiveForm.get('cod_adicional1')?.value);
        let puesto_adicional1 = this.obtenerPuesto(this.reactiveForm.get('id_puesto1')?.value);
        this.lstConfirmacionColaboradores.push({
          num_economico: num_economico,
          desc_ruta: this.descripcion_ruta,
          nombre_completo: nombre_adicional1,
          desc_puesto: puesto_adicional1,
          aprovechamiento: aprovechamiento?.nombre,
          clv_retardo: (this.reactiveForm.get('clv_retardo1')?.value == null || this.reactiveForm.get('clv_retardo1')?.value == 0 ? 'NO' : 'SI')
        });
      }
      if (this.reactiveForm.get('cod_adicional2')?.value != null) {
        let nombre_adicional2 = this.obtenerNombreColaborador(this.reactiveForm.get('cod_adicional2')?.value);
        let puesto_adicional2 = this.obtenerPuesto(this.reactiveForm.get('id_puesto2')?.value);
        this.lstConfirmacionColaboradores.push({
          num_economico: num_economico,
          desc_ruta: this.descripcion_ruta,
          nombre_completo: nombre_adicional2,
          desc_puesto: puesto_adicional2,
          aprovechamiento: aprovechamiento?.nombre,
          clv_retardo: (this.reactiveForm.get('clv_retardo2')?.value == null || this.reactiveForm.get('clv_retardo2')?.value == 0 ? 'NO' : 'SI')
        });
      }
      //cada vez que se abra el modal se vuelve a activar
      this.desactivarBotonGuardar = false;
      this.dspConfirmarAsignacion = true;
    }

  }

  obtenerNumeroEconomico(id_unidad_transporte: number): string {
    let nombre: string = '';
    this.lstUnidadesDisponibles.map((valor) => {
      if (valor.id_unidad_transporte == id_unidad_transporte) {
        nombre = valor.num_economico.toLocaleUpperCase();
      }
    });
    return nombre;
  }

  obtenerNombreColaborador(cod_chofer: number): string {
    let nombre: string = '';
    this.lstChoferesDisponibles.map((valor) => {
      if (valor.cod_chofer == cod_chofer) {
        nombre = valor.nombre_completo.toLocaleUpperCase();
      }
    });
    return nombre;
  }

  obtenerPuesto(id_puesto: number): string {
    let puesto: string = '';
    puesto = id_puesto == 1 ? 'DRIVER' : 'AUXILIAR';
    return puesto;
  }




  dbGuardarInformacionConfirmacion() {

  }



  cancelarMostrarConfirmacion() {
    this.reactiveForm.controls['id_puesto1'].setValue(this.reactiveForm.controls['id_puesto1'].value || null)
    this.reactiveForm.controls['id_puesto2'].setValue(this.reactiveForm.controls['id_puesto2'].value || null)
    this.reactiveForm.controls['cod_adicional1'].setValue(this.reactiveForm.controls['cod_adicional1'].value || null)
    this.reactiveForm.controls['cod_adicional2'].setValue(this.reactiveForm.controls['cod_adicional2'].value || null)
    this.dspConfirmarAsignacion = false;
    this.leyenda_chofer = '';
    this.leyenda_unidad = '';
    this.lstConfirmacionColaboradores = [];
  }

  //guardar rutas
  guardarUnidadaRutaxDia() {

    this.desactivarBotonGuardar = true;
    let fecha = this.reactiveForm.get('fecha')?.value;
    let id_ruta_travel: string = this.reactiveForm.get('id_ruta_travel')?.value == null
      || this.reactiveForm.get('id_ruta_travel')?.value == undefined
      || this.reactiveForm.get('id_ruta_travel')?.value == '' ? 'null' :
      this.reactiveForm.get('id_ruta_travel')?.value;
    let unidades: number = this.reactiveForm.get('unidades')?.value;
    let choferes: number = this.reactiveForm.get('choferes')?.value;

    //Formatear Fecha
    let format = fecha.split("-");
    let ultima_fecha = format[2] + '-' + format[1] + '-' + format[0];
    //usuario
    let clv_retardo_cast = this.reactiveForm.get('clv_retardo')?.value == null || this.reactiveForm.get('clv_retardo')?.value == false ? 0 : 1;
    let clv_retardo1_cast = this.reactiveForm.get('clv_retardo1')?.value == null || this.reactiveForm.get('clv_retardo1')?.value == false ? 0 : 1;
    let clv_retardo2_cast = this.reactiveForm.get('clv_retardo2')?.value == null || this.reactiveForm.get('clv_retardo2')?.value == false ? 0 : 1;


    //variables  de confirmaciond e cursos del check box itzael
    let clv_confirma_casetas = this.reactiveForm.get('clv_confirma_casetas')?.value == null || this.reactiveForm.get('clv_confirma_casetas')?.value == 0 ? 0 : 1;
    let clv_confirma_combustible = this.reactiveForm.get('clv_confirma_combustible')?.value == null || this.reactiveForm.get('clv_confirma_combustible')?.value == 0 ? 0 : 1;


    let id_puesto = 1;
    let id_puesto1 = this.reactiveForm.get('id_puesto1')?.value == null ? 0 : this.reactiveForm.get('id_puesto1')?.value;
    let id_puesto2 = this.reactiveForm.get('id_puesto2')?.value == null ? 0 : this.reactiveForm.get('id_puesto2')?.value;
    let cod_adicional1 = this.reactiveForm.get('cod_adicional1')?.value == null ? 0 : this.reactiveForm.get('cod_adicional1')?.value;
    let cod_adicional2 = this.reactiveForm.get('cod_adicional2')?.value == null ? 0 : this.reactiveForm.get('cod_adicional2')?.value;
    this.reactiveForm.get('id_puesto1')?.setValue(id_puesto1);
    this.reactiveForm.get('id_puesto2')?.setValue(id_puesto2);
    this.reactiveForm.get('cod_adicional1')?.setValue(cod_adicional1);
    this.reactiveForm.get('cod_adicional2')?.setValue(cod_adicional2);

    //Hora en Formato al Guardar
    var formattedDate = new Date().toLocaleString('es-MX', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false });
    var fecha_completa = fecha + 'T' + formattedDate;

    //if para la pantalla de editar utilizando el reactiveform
    if (this.id_pao_unidades != 0) {
      this.unidadService.postGuardarUnidadAlDia(
        3,
        this.id_pao_unidades,
        this.model.id_registro,
        this.model.id_ruta,
        fecha_completa,
        choferes,
        unidades,
        cod_adicional1,
        cod_adicional2,
        id_puesto,
        id_puesto1,
        id_puesto2,
        clv_retardo_cast,
        clv_retardo1_cast,
        clv_retardo2_cast,
        this.user.cod!,
        this.clv_especial,
        0,
        clv_confirma_combustible,
        clv_confirma_casetas,
        id_ruta_travel,
        this.reactiveForm.controls['id_tipo_aprovechamiento'].value,
        this.reactiveForm.controls['rostering_id'].value || ''


      ).subscribe((resp) => {
        this.resultado = resp;
        if (this.resultado.clv_estatus == -2) {
          this.mostrarDialogoInformativoAdicionales('<b>' + this.resultado.messageDetails + '</b>');
          this.cancelarMostrarConfirmacion();
        } else {
          this.mostrarDialogoFolioEditar(this.resultado.messageDetails);
          this.cancelarMostrarConfirmacion();
          this.cancelarAgregarUnidadyChofer();
          this.llenarInformacionAutomaticaDiaAlGuardar(fecha);
          this.DilogEditar = false;
          this.dspEditarConsulta = false;
        }
      },
        (error) => {
          this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error en <Guardar Servicio al Dia>', detail: 'Contacte al Administrador del Sitio' });
          this.desactivarBotonGuardar = false;
          this.DilogEditar = false;
          this.dspEditarConsulta = false;
        });
    }
    else {
      this.unidadService.postGuardarUnidadAlDia(2, 0,
        this.model.id_registro,
        this.model.id_ruta,
        fecha_completa,
        choferes,
        unidades,
        cod_adicional1,
        cod_adicional2,
        id_puesto,
        id_puesto1,
        id_puesto2,
        clv_retardo_cast,
        clv_retardo1_cast,
        clv_retardo2_cast,
        this.user.cod!,
        this.clv_especial,
        0,
        clv_confirma_combustible,
        clv_confirma_casetas,
        id_ruta_travel,
        this.reactiveForm.controls['id_tipo_aprovechamiento'].value,
        this.reactiveForm.controls['rostering_id'].value || ''
      ).subscribe((resp) => {
        this.resultado = resp;
        if (this.resultado.clv_estatus == -2) {
          this.mostrarDialogoInformativoAdicionales(this.resultado.messageDetails);
          this.cancelarMostrarConfirmacion();
        } else {

          this.mostrarDialogoFolio(this.resultado.messageDetails);
          this.cancelarMostrarConfirmacion();
          this.cancelarAgregarUnidadyChofer();
          this.llenarInformacionAutomaticaDiaAlGuardar(fecha);
          this.DilogEditar = false;
          this.dspEditarConsulta = false;
        }
      },
        (error) => {
          this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error en <Guardar Servicio al Dia>', detail: 'Contacte al Administrador del Sitio' });
          this.desactivarBotonGuardar = false;
          this.DilogEditar = false;
          this.dspEditarConsulta = false;
        });
    }

  }



  asignarValorUnidad() {
    let id_unidad_transporte = this.reactiveForm.get('unidades')?.value;
    this.selectedUnidad = id_unidad_transporte;

  }

  dialogServicio() {
    this.dspServicios = true;
    this.ServiciosSinFinalizar = [];
  }

  ComprobarServicio() {
    this.loadingServicios = true;
    var anio = String(this.fecha_filtrada).substring(0, 4);
    var mes = String(this.fecha_filtrada).substring(5, 7);
    this.choferService.postObtenerListadoServiciosFinalizar(Number(mes), Number(anio)).subscribe((resp) => {
      this.ServiciosSinFinalizar = resp;

      setTimeout(() => {
        this.loadingServicios = false;
      },
        900);
    },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error en <servicio>', detail: 'Contacte al Administrador del Sitio' });
      this.loadingServicios = false;
      });
  }

  asignarValorFecha() {
    this.lstOperacionDiariaReal = [];
    this.fecha_dia = this.fecha_filtrada;
    // this.fecha_dia =this.fecha_fil_sin_reg;
  }

  revPermiteAgregar(): boolean {
    let diaActual: Date = new Date();
    let diasMas = new Date(diaActual.setDate(diaActual.getDate() + 1));

    let fecha_filtrada = new Date(this.fecha_filtrada);
    let dia_final = new Date(this.fecha_dia_final);

    if (fecha_filtrada < dia_final || fecha_filtrada > diasMas)
      return true;

    else
      return false;
  }

  nombre_cliente: string = '';
  agregarUnidadxDia(data: IOperacionDia, clv_especial: number, num_opcion_categoria: number) {
    this.id_pao_unidades = 0;
    this.reactiveForm.reset();
    this.descripcion_ruta = '';
    this.clv_especial = clv_especial;
    this.reactiveForm.controls['fecha'].setValue(data.fecha.substring(0, 10));
    this.model = {
      id_registro: data.idx_pao_diario,
      id_tipo_transporte: data.id_tipo_transporte,
      id_ciudad: data.id_ciudad,
      id_ruta: data.id_ruta,
      fecha: data.fecha,
      clv_operacion: data.clv_operacion,
    };
    this.descripcion_ruta = data.nombre_ruta;
    this.nombre_ruta_Editable = data.nombre_ruta;
    this.fecha_dia_editable = data.fecha.substring(0, 10);

    this.reactiveForm.controls['clv_confirma_combustible'].setValue(true);
    this.reactiveForm.controls['clv_confirma_casetas'].setValue(true);
    this.reactiveForm.get('unidades')!.disable();
    this.dsbUnidad = true;
    let num_opc = this.lstOperacionDiariaReal[0].clv_operacion == 3 ? 4 : num_opcion_categoria;
    this.unidadService.getListadoUnidadesDisponiblesAlDia(num_opc, data.id_tipo_transporte, data.id_ciudad, data.fecha, data.id_ruta).subscribe((resp) => {
      this.lstUnidadesDisponibles = resp;
      if (this.lstUnidadesDisponibles.length == 0) {
        this.mostrarDialogoInformativoSinInformacion('No hay Unidades Disponibles para la Ruta. Considere un servicio Especial.');
      } else {
        this.reactiveForm.get('unidades')!.enable();
        this.dsbUnidad = false;
      } setTimeout(() => {
      },
        900);
    },
      (error) => {
        this.dsbUnidad = true;
        this.reactiveForm.get('unidades')!.disable();
        this.dspEditar = false;
        this.messageService.add({ severity: 'error', summary: 'Error en <Unidad Disponible>', detail: 'Contacte al Administrador del Sitio' });
      });

    //Cargar Listado de Choferes Disponibles
    this.dsbChofer = true;
    this.reactiveForm.get('choferes')!.disable();
    this.choferService.getListadoChoferesDisponiblesAlDia(num_opcion_categoria, data.id_tipo_transporte, data.id_ciudad, data.fecha, data.id_ruta).subscribe((resp) => {
      this.lstChoferesDisponibles = resp;
      this.lstChoferesDisponibles.map(x => x.deshabilitado = Boolean(x.disabled == undefined ? 0 : x.disabled));
      if (this.lstChoferesDisponibles.length == 0) {
        this.mostrarDialogoInformativoSinInformacion('No hay Colaboradores Disponibles para la Ruta. Considere una ruta Especial.');
      } else {
        this.reactiveForm.get('choferes')!.enable();
        this.dsbChofer = false;
      }
      setTimeout(() => {
      },
        900);
    },
      (error) => {
        this.dsbChofer = true;
        this.reactiveForm.get('choferes')!.disable();
        this.dspEditar = false;
        this.messageService.add({ severity: 'error', summary: 'Error en <Colaborador Disponible>', detail: 'Contacte al Administrador del Sitio' });
      });

    this.changeInput(data.clv_ruta_travel);
    this.nombre_cliente = data.nombre_cliente
    this.dspEditar = true;
  }



  changeInput(clv_ruta_travel: boolean) {
    if (this.clv_especial == 2) {
      this.reactiveForm.controls['id_ruta_travel'].clearValidators();
      this.reactiveForm.controls['id_ruta_travel'].setValidators([Validators.maxLength(25)]);
      this.reactiveForm.controls['id_ruta_travel'].updateValueAndValidity();
      this.reactiveForm.controls['rostering_id'].clearValidators();
      this.reactiveForm.controls['rostering_id'].setValidators([Validators.maxLength(25)]);
      this.reactiveForm.controls['rostering_id'].updateValueAndValidity();
    }
    else {
      if (clv_ruta_travel) {
        this.reactiveForm.controls['id_ruta_travel'].clearValidators();
        this.reactiveForm.controls['id_ruta_travel'].setValidators([Validators.required, Validators.minLength(7), Validators.maxLength(8), Validators.pattern(this.REGEX_names)]);
        this.reactiveForm.controls['id_ruta_travel'].updateValueAndValidity();
        this.reactiveForm.controls['rostering_id'].clearValidators();
        this.reactiveForm.controls['rostering_id'].setValidators([Validators.required, Validators.minLength(8), Validators.maxLength(8), Validators.pattern(this.REGEX_names2)]);
        this.reactiveForm.controls['rostering_id'].updateValueAndValidity();
      }
      else {
        this.reactiveForm.controls['id_ruta_travel'].clearValidators();
        this.reactiveForm.controls['id_ruta_travel'].setValidators([Validators.maxLength(25)]);
        this.reactiveForm.controls['id_ruta_travel'].updateValueAndValidity();
        this.reactiveForm.controls['rostering_id'].clearValidators();
        this.reactiveForm.controls['rostering_id'].setValidators([Validators.maxLength(25)]);
        this.reactiveForm.controls['rostering_id'].updateValueAndValidity();
      }
    }
  }


  editarUnidadxDia(data: IMovDiarioUnidad) {

    this.nombre_cliente = data.nombre_cliente || '';
    //limpiar formulario
    this.reactiveForm.reset();
    this.lstConfirmacionColaboradores = [];
    this.descripcion_ruta = '';
    this.clv_especial = data.clv_especial;
    let clv_especial = 1;
    this.id_pao_unidades = data.idx;
    this.descripcion_ruta = data.nombre_ruta != undefined ? data.nombre_ruta : '';
    //Informacion a Mostrar en el encabezado
    this.nombre_ruta_Editable = data.nombre_ruta != undefined ? data.nombre_ruta : '';
    this.fecha_dia_editable = data.fecha.substring(0, 10);


    //El servicio para mostrar las unidades disponibles
    this.dsbUnidad = true;
    this.changeInput(data.clv_ruta_travel);

    this.unidadService.getListadoUnidadesDisponiblesAlDia(4, this.model.id_tipo_transporte, this.model.id_ciudad, this.model.fecha, this.model.id_ruta).subscribe((resp) => {
      this.lstUnidadesDisponibles = resp;

      if (this.lstUnidadesDisponibles.length == 0) {
        this.mostrarDialogoInformativoSinInformacion('No hay Unidades Disponibles para la Ruta. Considere un servicio Especial.');
      } else {
        this.reactiveForm.get('unidades')!.enable();
        this.dsbUnidad = false;
      }
    },
      (error) => {
        this.dsbUnidad = true;
        this.reactiveForm.get('unidades')!.disable();
        this.DilogEditar = false;
        this.messageService.add({ severity: 'error', summary: 'Error en <Unidad Disponible>', detail: 'Contacte al Administrador del Sitio' });
      });


    //Cargar Listado de Choferes Disponibles
    this.dsbChofer = true;
    this.reactiveForm.get('choferes')!.disable();
    this.choferService.getListadoChoferesDisponiblesAlDia(2, this.model.id_tipo_transporte, this.model.id_ciudad, this.model.fecha, this.model.id_ruta).subscribe((resp) => {
      this.lstChoferesDisponibles = resp;
      this.lstChoferesDisponibles.map(x => x.deshabilitado = Boolean(x.disabled == undefined ? 0 : x.disabled));
      if (this.lstChoferesDisponibles.length == 0) {
        this.mostrarDialogoInformativoSinInformacion('No hay Colaboradores Disponibles para la Ruta. Considere una ruta Especial.');
      } else {
        this.reactiveForm.get('choferes')!.enable();
        this.dsbChofer = false;
      }
    },
      (error) => {
        this.dsbChofer = true;
        this.reactiveForm.get('choferes')!.disable();
        this.DilogEditar = false;
        this.messageService.add({ severity: 'error', summary: 'Error en <Colaborador Disponible>', detail: 'Contacte al Administrador del Sitio' });
      });


    //se inserta la informaciopn ya cargada
    this.reactiveForm.controls['fecha'].setValue(data.fecha.substring(0, 10));
    this.reactiveForm.controls['clv_retardo'].setValue(data.clv_retardo);
    this.reactiveForm.controls['id_puesto1'].setValue(data.id_puesto1 == 0 ? null : data.id_puesto1);
    this.reactiveForm.controls['id_puesto2'].setValue(data.id_puesto2 == 0 ? null : data.id_puesto2);
    this.reactiveForm.controls['unidades'].setValue(data.id_unidad_transporte);
    this.reactiveForm.controls['cod_adicional1'].setValue(data.cod_adicional1 == 0 ? null : data.cod_adicional1);
    this.reactiveForm.controls['cod_adicional2'].setValue(data.cod_adicional2 == 0 ? null : data.cod_adicional2);
    this.reactiveForm.controls['choferes'].setValue(data.cod_chofer);
    this.reactiveForm.controls['clv_confirma_combustible'].setValue(data.clv_confirma_combustible == 1 ? true : false);
    this.reactiveForm.controls['clv_confirma_casetas'].setValue(data.clv_confirma_casetas == 1 ? true : false);
    this.reactiveForm.controls['clv_retardo'].setValue(data.clv_retardo == 1 ? true : false);
    this.reactiveForm.controls['id_ruta_travel'].setValue(data.id_ruta_travel);
    this.reactiveForm.controls['id_tipo_aprovechamiento'].setValue(data.id_tipo_aprovechamiento);
    this.reactiveForm.controls['rostering_id'].setValue(data.rostering_id || '');
    if (this.lstChoferesDisponibles.length > 0) {
      this.lstChoferesDisponibles.map((valor) => {
        valor.disabled = 0;
      });
    }
    this.DilogEditar = true;

  }


  consultaInformacionDeUnidades(data: IOperacionDia) {

    this.model = {
      id_registro: data.idx_pao_diario,
      id_tipo_transporte: data.id_tipo_transporte,
      id_ciudad: data.id_ciudad,
      id_ruta: data.id_ruta,
      fecha: data.fecha,
      clv_operacion: data.clv_operacion,
    };
    //Informacion a Mostrar en el encabezado
    this.nombre_ruta_Editable = data.nombre_ruta;
    this.fecha_dia_editable = data.fecha.substring(0, 10);
    if (data.num_real > 0) {
      this.cargarInformacionDeMovDiarioUnidades(data.idx_pao_diario, data.id_ruta, data.fecha, data.nombre_proyecto);


    }

    //variables para el  editar la fecha de 3 dias
    let var1 = new Date(this.fecha_filtrada);
    let var2 = new Date(this.fecha_dia_final);

    //funcionalidad para poder editar en el lapso de 3 dias itzael
    if (this.model.clv_operacion == 3) {
      this.permite_editar = false;

    }
    else {
      this.permite_editar = true;

    }

    if (this.model.clv_operacion == 1) {
      this.permite_editar = (var1 < var2 || var1 > var2);
    }
    //permite editar para usuarios no administradores
    if (this.model.clv_operacion == 3) {
      this.permite_eliminar = false;
    }
    else if (this.model.clv_operacion == 1) {

      this.permite_eliminar = true;
    }

    if (this.model.clv_operacion == 1 && (this.fecha_filtrada == this.fecha_dia_final)) {
      this.permite_eliminar = false;
    }

  }

  cancelarAgregarUnidadyChofer() {
    this.dspEditar = false;
    this.clv_especial = 0;
    this.id_pao_unidades = 0;
    //limpiar formulario
    this.DilogEditar = false;
    this.reactiveForm.reset();

  }

  cancelarMostrarConsulta() {
    this.dspEditarConsulta = false;
    this.loading = false;
    this.id_pao_unidades = 0;
    this.tipo_aprovechamiento = '';
  }

  limpiarfiltrosTabla() {
    this.dt.clear();
  }





  getserviciossinruta() {

    this.lstsinServicio = []
    this.loading_sin = true;
    const fechaCasteada = new Date(this.fecha_fil_sin_reg).toISOString().substring(0, 10);
    this.unidadService.getserviciossinruta(fechaCasteada).subscribe((resp) => {
      this.lstsinServicio = resp;
      setTimeout(() => {
        this.loading_sin = false;
        this.habilitaragregar = false;
        this.clv_operacion_sinruta =
          (this.lstsinServicio.length == 0 && this.fecha_fil_sin_reg > this.fecha_dia_final) ? 0
            : (this.lstsinServicio.length > 0 ? this.lstsinServicio[0].clv_operacion_sinruta : 0)
      }, 500);
    }, (error) => {
      this.loading_sin = false;
      this.habilitaragregar = true;
      this.mostrarDialogoInformativoSinInformacion('<b>Error al obtener listado</b>. de servicios sin informacion.');
    });
  }





  //guardar rutas
  guardarUnidadadsinruta() {
    if (this.clv_operacion == 0 && this.sinservicioForm.controls['fecha_fil_sin_reg'].value < this.fecha_dia_final) {
      this.messageService.add({ key: 'msj', severity: 'info', summary: 'Advertencia', detail: ' No cuenta con permisos para agregar servicios de una fecha anterior a la actual.' });
    } else {
      this.desactivarBotonGuardar = true;
      let data_enviar: IpostguardarUnidadadsinruta = {
        id_unidad_transporte: this.sinservicioForm.controls['id_unidad_transporte'].value,
        cod_chofer: this.sinservicioForm.controls['cod_chofer'].value,
        id_ruta_travel: this.sinservicioForm.controls['id_ruta_travel'].value,
        id_ciudad_hm: 9,
        cod_adicional1: this.sinservicioForm.get('cod_adicional1')?.value == null ? 0 : this.sinservicioForm.get('cod_adicional1')?.value,
        cod_adicional2: this.sinservicioForm.get('cod_adicional2')?.value == null ? 0 : this.sinservicioForm.get('cod_adicional2')?.value,
        id_puesto1: this.sinservicioForm.get('id_puesto1')?.value == null ? 0 : this.sinservicioForm.get('id_puesto1')?.value,
        id_puesto2: this.sinservicioForm.get('id_puesto2')?.value == null ? 0 : this.sinservicioForm.get('id_puesto2')?.value,
        id_tipo_aprovechamiento: this.sinservicioForm.controls['id_tipo_aprovechamiento'].value,
        fecha_fil_sin_reg: this.sinservicioForm.controls['fecha_fil_sin_reg'].value,
        cod_usuario: this.user.cod == undefined ? '0999' : this.user.cod,
        rostering_id: this.sinservicioForm.controls['rostering_id'].value || '',
      }

      this.unidadService.guardarUnidadadsinruta(data_enviar).subscribe((resp) => {
        this.resultado = resp;
        if (this.resultado.clv_estatus == -2) {
          this.mostrarDialogoInformativoAdicionales(this.resultado.messageDetails);
          this.cancelarMostrarConfirmacion();
        } else {
          this.mostrarDialogoFolio_Sinruta(this.resultado.messageDetails);
          this.llenarInformacionAutomaticaDiaAlGuardar(this.sinservicioForm.controls['fecha_fil_sin_reg'].value);
          this.getserviciossinruta();
          this.cancelarserviciossinruta()
        }
      },
        (error) => {
          this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error en <Guardar Servicio al Dia>', detail: 'Contacte al Administrador del Sitio' });
          this.desactivarBotonGuardar = false;
          this.dspEditarConsulta = false;
        });
    }

  }



  mostrarDialogoFolio_Sinruta(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario;
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Asignación de Folio',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'success', summary: 'Actualización', detail: 'La informacion se almaceno de forma correcta' });
      },
      key: "folio"
    });
  }

  dspagregarruta: boolean = false
  clv_operacion_sin_ruta: number = 0;

  habiliatragregarruta(fol: ISinServicio) {

    this.llenarInformacionAutomaticaDia_sinruta(fol);

    this.sinservicioForm.controls['id_ciudad_hm'].setValue(fol.id_ruta_travel)
    this.sinservicioForm.controls['fecha_fil_sin_reg'].setValue(fol.fecha),
      this.sinservicioForm.controls['cod_chofer'].setValue(fol.cod_chofer),
      this.sinservicioForm.controls['id_unidad_transporte'].setValue(fol.id_unidad_transporte)
    this.sinservicioForm.controls['cod_adicional1'].setValue(fol.cod_adicional1),
      this.sinservicioForm.controls['cod_adicional2'].setValue(fol.cod_adicional2),
      this.sinservicioForm.controls['id_puesto1'].setValue(fol.id_puesto1),
      this.sinservicioForm.controls['id_puesto2'].setValue(fol.id_puesto2),
      this.sinservicioForm.controls['id_ruta_travel'].setValue(fol.id_ruta_travel),
      this.sinservicioForm.controls['id_tipo_aprovechamiento'].setValue(fol.id_tipo_aprovechamiento)
    this.sinservicioForm.controls['folio_serviciosinruta'].setValue(fol.folio_serviciosinruta)
    this.sinservicioForm.controls['id_folio'].setValue(fol.id_folio)
    this.sinservicioForm.controls['fecha_fil_sin_reg'].setValue(fol.fecha)
    this.sinservicioForm.controls['rostering_id'].setValue(fol.rostering_id || '')
    this.dspagregarruta = true;
  }

  cancelarhabiliatragregarruta() {
    this.dspagregarruta = false;
    this.lstOperacionDiariaReal_sinruta = []
    this.sinservicioForm.reset();
    this.sinservicioForm.controls['fecha_fil_sin_reg'].setValue(new Date().toISOString().substring(0, 10))
    this.sinservicioForm.controls['id_ciudad_hm'].setValue(9)

  }
  clv_operacion_sinruta: number = 0
  cargarsinruta() {
    this.lstsinServicio = []
    this.dspsinruta = true
  }
  cancelarsinruta() {
    this.loading_sin = false;
    this.dspsinruta = false;
    this.habilitaragregar = true;
    this.lstsinServicio = [];
    this.fecha_fil_sin_reg = new Date().toISOString().substring(0, 10);
    this.cancelarhabiliatragregarruta();
    this.cancelarserviciossinruta();

  }

  cancelarserviciossinruta() {
    this.Dspaddsinruta = false;
    this.sinservicioForm.reset();
    this.sinservicioForm.controls['fecha_fil_sin_reg'].setValue(new Date().toISOString().substring(0, 10))
    this.sinservicioForm.controls['id_ciudad_hm'].setValue(9)

  }


  limpiarlista() {
    this.lstsinServicio = [];
    this.habilitaragregar = true;
  }


  limpiarlistacriterio() {
    this.lstcriterio = [];
  }

  addserviciossinruta() {
    this.sinservicioForm.controls['id_ruta_travel'].setValidators([Validators.required, Validators.pattern(this.REGEX_names)]);

    //Cargar lista de unidades
    this.unidadService.getListadoUnidadesDisponiblesAlDia_sinservico(2, 1, 9, this.fecha_fil_sin_reg, 0).subscribe((resp) => {
      this.lstUnidadesDisponibles = resp;
      if (this.lstUnidadesDisponibles.length == 0) {
        this.mostrarDialogoInformativoSinInformacion('No hay Unidades Disponibles para la Ruta. Considere un servicio Especial.');
      } else {
        this.reactiveForm.get('unidades')!.enable();
      } setTimeout(() => {
      },
        900);
    },
      (error) => {

        this.reactiveForm.get('unidades')!.disable();
        this.dspEditar = false;
        this.messageService.add({ severity: 'error', summary: 'Error en <Unidad Disponible>', detail: 'Contacte al Administrador del Sitio' });
      });

    //Cargar Listado de Choferes Disponibles
    this.reactiveForm.get('choferes')!.disable();
    this.choferService.getListadoChoferesDisponiblesAlDia_sinservicio(2, 1, 9, this.fecha_fil_sin_reg).subscribe((resp) => {
      this.lstChoferesDisponibles = resp;
      this.lstChoferesDisponibles.map(x => x.deshabilitado = Boolean(x.disabled == undefined ? 0 : x.disabled));
      if (this.lstChoferesDisponibles.length == 0) {
        this.mostrarDialogoInformativoSinInformacion('No hay Colaboradores Disponibles para la Ruta. Considere una ruta Especial.');
      } else {
        this.reactiveForm.get('choferes')!.enable();
        this.dsbChofer = false;
      }
      setTimeout(() => {
      },
        900);
    },
      (error) => {
        this.reactiveForm.get('choferes')!.disable();
        this.dspEditar = false;
        this.messageService.add({ severity: 'error', summary: 'Error en <Colaborador Disponible>', detail: 'Contacte al Administrador del Sitio' });
      });
    this.Dspaddsinruta = true;
    this.sinservicioForm.controls['id_ciudad_hm'].disable()
  }




  llenarInformacionAutomaticaDia_sinruta(fol: ISinServicio) {
    this.loading_sin_rut = true;
    this.proyeccionService.getListadoOpDia_sinruta(1, fol.fecha, this.user.cod).subscribe((resp) => {
      setTimeout(() => {
        this.loading_sin_rut = false;
        this.lstOperacionDiariaReal_sinruta = resp;
        this.clv_operacion_sin_ruta = this.lstOperacionDiariaReal[0].clv_operacion;

        this.clv_pa = resp.length > 0 ? resp[0].clv_pa : 0;
        if (this.lstOperacionDiariaReal_sinruta.length == 0) {
          this.loading_sin_rut = false;
          this.mostrarDialogoInformativoSinInformacion('<b>No Existe</b> información de Rutas para la Fecha seleccionada');
        }
        else {
          this.clv_operacion = resp[0].clv_operacion;
        }
      },
        600);
    },
      (error) => {
        this.mostrarDialogoInformativoSinInformacion('<b>ERROR</b> en Cargar Movimientos del Dia(Operación Diaria- ' + this.fecha_dia + ' )');
        this.loading_sin_rut = false;
      });
  }



  //guardar todo el pedo
  guardaragregarruta(fol: IOperacionDia) {

    this.loading_sin_rut = true
    this.unidadService.postGuardarUnidadAlDia_sin_ruta(
      1,
      0,
      fol.idx_pao_diario,
      fol.id_ruta,
      this.sinservicioForm.controls['fecha_fil_sin_reg'].value,
      this.sinservicioForm.controls['cod_chofer'].value,
      this.sinservicioForm.controls['id_unidad_transporte'].value,
      this.sinservicioForm.get('cod_adicional1')?.value == null ? 0 : this.sinservicioForm.get('cod_adicional1')?.value,
      this.sinservicioForm.get('cod_adicional2')?.value == null ? 0 : this.sinservicioForm.get('cod_adicional2')?.value,
      1,
      this.sinservicioForm.get('id_puesto1')?.value == null ? 0 : this.sinservicioForm.get('id_puesto1')?.value,
      this.sinservicioForm.get('id_puesto2')?.value == null ? 0 : this.sinservicioForm.get('id_puesto2')?.value,
      0,
      0,
      0,
      this.user.cod == undefined ? '0999' : this.user.cod,
      1,
      0,
      1,
      1,
      this.sinservicioForm.controls['id_ruta_travel'].value,
      this.sinservicioForm.controls['id_tipo_aprovechamiento'].value,
      this.sinservicioForm.controls['id_folio'].value,
      this.sinservicioForm.controls['rostering_id'].value || '',
    ).subscribe((resp) => {
      this.resultado = resp;
      this.cancelarhabiliatragregarruta();
      this.getserviciossinruta()
      if (this.resultado.clv_estatus == -2) {
        this.mostrarDialogoInformativoAdicionales(this.resultado.messageDetails);
        this.loading_sin_rut = false;
      } else {
        this.mostrarDialogoFolio(this.resultado.messageDetails);
        this.loading_sin_rut = false;
        this.llenarInformacionAutomaticaDia();
      }
    },
      (error) => {
        this.loading_sin_rut = false;
        this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error en <Guardar Servicio al Dia>', detail: 'Contacte al Administrador del Sitio' });
      });

  }


  //Elimina servicios sin ruta

  eliminarmovsin(fol: ISinServicio) {

    this.sinservicioForm.controls['id_unidad_transporte'].setValue(fol.id_unidad_transporte)
    this.sinservicioForm.controls['id_ruta_travel'].setValue(fol.id_ruta_travel),
      this.sinservicioForm.controls['id_folio'].setValue(fol.id_folio)
    this.confirmationService.confirm({
      message: '¿Está seguro de que desea eliminar el servicio sin ruta con el folio: <b>' + fol.folio_serviciosinruta + '</b>?',
      header: 'Confirmación',
      icon: 'pi pi-info-circle',
      accept: () => {
        let data_enviar = {
          id_unidad_transporte: this.sinservicioForm.controls['id_unidad_transporte'].value,
          cod_usuario: this.user.cod == undefined ? '0999' : this.user.cod,
          id_ruta_travel: this.sinservicioForm.controls['id_ruta_travel'].value,
          id_folio: this.sinservicioForm.controls['id_folio'].value,
        }
        this.loading_sin = true
        this.unidadService.eliminarmovsin(data_enviar).subscribe((resp) => {
          this.resultado = resp;
          setTimeout(() => {
            this.cancelarhabiliatragregarruta();
            this.getserviciossinruta()
            this.loading_sin = false
            this.messageService.add({ key: 'msj', severity: 'success', summary: 'Actualización', detail: 'La informacion se almaceno de forma correcta' });
          }, 600);
        },
          (error) => {
            this.loading_sin = false;
            this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error en <Guardar Servicio al Dia>', detail: 'Contacte al Administrador del Sitio' });
          });

      },
    })
  }



  num_opcion: number = 0
  num_ac: number = 0
  finalizaroperacion(data: any, num_opcion: number, num_ac: number) {

    let texto = num_opcion == 2 ? ' <b>CANCELAR</b> la finalización  por Operaciones del' : '<b>FINALIZAR</b> el'
    let ruta = this.lstOperacionDiariaUnidades.findIndex(x => x.idx_pao_diario == data.idx_pao_diario);
    let desc_folio = ruta == -1 ? data.num_folio : this.lstOperacionDiariaUnidades[ruta].desc_folio;
    this.confirmationService.confirm({
      message: '¿Está seguro de que desea ' + texto + ' servicio  folio: <b>' + desc_folio + '</b>?',
      header: 'Confirmación',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.loadingEditar = true
        this.unidadService.finalizaroperacion(num_opcion, data.idx, this.user.cod == undefined ? '0999' : this.user.cod, num_ac).subscribe((resp) => {
          this.resultado = resp;
          setTimeout(() => {
            if (ruta == -1) this.ComprobarServicio();
            else this.cancelarMostrarConsulta();

            this.loadingEditar = false
            this.messageService.add({ key: 'msj', severity: 'success', summary: 'Actualización', detail: 'La informacion se almaceno de forma correcta' });
          }, 600);
        },
          (error) => {
            this.loadingEditar = false;
            this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error en la opcion de <Finalizar servicio>', detail: 'Contacte al Administrador del Sitio' });
          });


      },
    })
  }

  loadingcriterio: boolean = false;
  lstcriterio: ICriterio[] = [];





  getcriterio() {
    this.loading_reporte = true;
    this.loadingcriterio = true;
    const ciudad = this.criterioForm.controls['id_ciudad_hm'].value;
    const fecha = this.criterioForm.controls['fecha_fil'].value;
    const fechaObj = new Date(fecha);

    if ( !fecha || ciudad == null||  isNaN(fechaObj.getTime())) {
      this.messageService.add({
        key: 'msj',
        severity: 'info',
        summary: 'Advertencia',
        detail: 'Es necesario seleccionar Ciudad y Fecha para cargar la información.'
      });
      this.loading_reporte = false;
      this.loadingcriterio = false;
      return;
    };

    const fechaCasteada = fechaObj.toISOString().substring(0, 10);
    let numopc = this.lstOperacionDiariaReal[0].clv_operacion
    let fechaActual: any = new Date();
    fechaActual.setDate(fechaActual.getDate() - 1);

    let fechaConDosDiasMenos: string = fechaActual.toISOString().substring(0, 10);



      this.lstcriterio = []


      this.unidadService.getcriterio(this.criterioForm.controls['id_ciudad_hm'].value, fechaCasteada).subscribe((resp) => {
        this.lstcriterio = resp;
        setTimeout(() => {
          this.loadingcriterio = false;
          this.loading_reporte = false;
        }, 500);
      }, (error) => {
        this.loadingcriterio = false;
        this.loading_reporte = false;

        this.mostrarDialogoInformativoSinInformacion('<b>Error al obtener listado</b>. de servicios sin informacion.');
      });

  }


  dspcriterio: boolean = false;


  ConsultarCriterio() {
    this.dspcriterio = true;
      const y = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
      const m = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
      const d = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
      var dateFormat = y + "-" + m + "-" + d;
     this.criterioForm.controls['fecha_fil'].setValue(dateFormat)
  }



  cancelarCriterio() {
    this.dspcriterio = false;
    this.criterioForm.reset()
    // this.criterioForm.controls['fecha_fil'].setValue(new Date().toISOString().substring(0, 10));
    this.lstcriterio = [];
  }

  loading_reporte: boolean = false

  exportarExcel() {

    this.loading_reporte = true;
    this.loadingcriterio=true;
    const ciudad = this.criterioForm.controls['id_ciudad_hm'].value;
    const fecha = this.criterioForm.controls['fecha_fil'].value;
    // Descomponer la fecha manualmente para evitar el desfase por UTC
    const [year, month, day] = fecha.split('-').map(Number);
    const fechaObj = new Date(year, month - 1, day); // Fecha correcta en hora local

    // const fechaObj = new Date(fecha);

    if ( !fecha || ciudad == null||  isNaN(fechaObj.getTime())) {
      this.messageService.add({
        key: 'msj',
        severity: 'info',
        summary: 'Advertencia',
        detail: 'Es necesario seleccionar Ciudad y Fecha para generar el reporte.'
      });
      this.loading_reporte = false;
      this.loadingcriterio = false;
      return;
    };


    let numopc = this.lstOperacionDiariaReal[0].clv_operacion
   const fechaCasteada = fechaObj.toISOString().substring(0, 10);
  // Restar 6 días
    const fechaMenos6Dias = new Date(fechaObj);
    fechaMenos6Dias.setDate(fechaMenos6Dias.getDate() - 6);
    const y = fechaMenos6Dias.toLocaleDateString('es-MX', { year: 'numeric' });
    const m = fechaMenos6Dias.toLocaleDateString('es-MX', { month: '2-digit' });
    const d = fechaMenos6Dias.toLocaleDateString('es-MX', { day: '2-digit' });
    const fechaFormateada = `${y}-${m}-${d}`;
    this.unidadService.rptcriterio(this.criterioForm.controls['id_ciudad_hm'].value, fechaCasteada).subscribe((resp: any[]) => {
      if (resp.length === 0 || typeof resp === 'undefined') {
        this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> No existe informacion del Catalogo para exportar(Excel)');
        this.loading_reporte = false;
        this.loadingcriterio = false;
      } else {
        import("xlsx").then(xlsx => {
          const worksheet = xlsx.utils.json_to_sheet(resp);
          const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
          const excelBuffer: any = xlsx.write(workbook, {
            bookType: "xlsx",
            type: "array"
          });

          this.saveAsExcelFile(excelBuffer, "ReporteCriterio" + '_'+fechaFormateada+'_AlDia_'+fechaCasteada);
        });
        setTimeout(() => {

          this.loading_reporte = false;
          this.loadingcriterio = false;
        }, 1000);
      }
    },
      (error) => {
        this.loading_reporte = false;
        this.loadingcriterio = false;
        this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'Error en emitir el reporte de Estatus de Facturación.' });
      });


  }


  mostrarDialogoInformativo(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '.';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
        this.messageService.clear();
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
        this.messageService.clear();
      },
      key: "sinInformacionDialog"
    });
    this.loading = false;
    this.messageService.clear();
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    //var FileSaver = require('file-saver');
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    saveAs(data, fileName + "_export_" + dateFormat + EXCEL_EXTENSION);
  }

  consultarMantenimiento() {
    this.dspMantenimiento = true;
    this.consMantenimientoForm.controls['id_ciudad_hm'].setValue(null);
  }

  cancelarMantenimiento() {
    this.dspMantenimiento = false;
    this.consMantenimientoForm.reset();
    // this.criterioForm.controls['fecha_fil'].setValue(new Date().toISOString().substring(0, 10));
    this.lstManteniento = [];
  }

  getMantenimiento() {
    this.loadingManetnimiento = true;
    const ciudad = this.consMantenimientoForm.controls['id_ciudad_hm'].value;
    if ( ciudad == null) {
      this.messageService.add({
        key: 'msj',
        severity: 'info',
        summary: 'Advertencia',
        detail: 'Es necesario seleccionar Ciudad para cargar la información.'
      });
      this.loadingManetnimiento = false;
      return;
    };
    this.lstManteniento = [];
    this.unidadService.getConsultaMantenimiento(ciudad).subscribe((resp) => {
      this.lstManteniento = resp;
      setTimeout(() => {
        this.loadingManetnimiento = false;
      }, 500);
    }, (error) => {
      this.loadingManetnimiento = false;

      this.mostrarDialogoInformativoSinInformacion('<b>Error al obtener listado de Mantenimiento</b>. de servicios sin informacion.');
    });
  }
  exportarExcelMantenimiento(){
   this.loadingManetnimiento_reporte = true;
    const ciudad = this.consMantenimientoForm.controls['id_ciudad_hm'].value;
    // Descomponer la fecha manualmente para evitar el desfase por UTC
    const fecha = new Date()
    const fechaSTR = fecha.toISOString().substring(0, 10);
    //const [year, month, day] = fecha.split('-').map(Number);
    //const fechaObj = new Date(year, month - 1, day); // Fecha correcta en hora local

    // const fechaObj = new Date(fecha);

    if ( !fecha || ciudad == null||  isNaN(fecha.getTime())) {
      this.messageService.add({
        key: 'msj',
        severity: 'info',
        summary: 'Advertencia',
        detail: 'Es necesario seleccionar Ciudad y Fecha para generar el reporte.'
      });
      this.loadingManetnimiento_reporte = false;
      return;
    };
    this.unidadService.getrptConsultaMantenimiento(this.consMantenimientoForm.controls['id_ciudad_hm'].value)
    .subscribe((resp: any[]) => {
      if (resp.length === 0 || typeof resp === 'undefined') {
        this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> No existe informacion del Catalogo para exportar(Excel)');
        this.loadingManetnimiento_reporte = false;
      } else {
        import("xlsx").then(xlsx => {
          const worksheet = xlsx.utils.json_to_sheet(resp);
          const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
          const excelBuffer: any = xlsx.write(workbook, {
            bookType: "xlsx",
            type: "array"
          });
          this.saveAsExcelFile(excelBuffer, "ReporteEstatusMantenimiento");
          // this.saveAsExcelFile(excelBuffer, "ReporteEstatusMantenimiento" + '_'+fechaFormateada+'_AlDia_'+fechaCasteada);
        });
        setTimeout(() => {

          this.loadingManetnimiento_reporte = false;
        }, 1000);
      }
    },
      (error) => {
        this.loadingManetnimiento_reporte = false;
        this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'Error en emitir el reporte de Estatus de Mantenimiento.' });
      });
  }
}
